import { render, staticRenderFns } from "./AddEcosystems.vue?vue&type=template&id=66d082e7&"
import script from "./AddEcosystems.vue?vue&type=script&lang=js&"
export * from "./AddEcosystems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports